/**
 * Enum representing the different roles available in a franchise.
 *
 * This enum is used to define the various roles that a user can have within the franchise system.
 * Each role is assigned a numeric value which helps in managing user access control and permissions.
 *
 * Enum Values:
 * - `OWNER`: The role for the owner of the franchise. Assigned a value of 0.
 * - `ADMIN`: The administrative role with higher permissions. Assigned a value of 1.
 * - `MANAGER`: The role for managers within the franchise. Assigned a value of 2.
 * - `USER`: A regular user with limited access. Assigned a value of 3.
 * - `DELIVERY`: The role for delivery personnel. Assigned a value of 4.
 *
 * @enum {number}
 */
export enum FranchiseRole {
  /**
   * Represents the franchise owner role with the highest level of access.
   */
  OWNER = 0,

  /**
   * Represents the administrative role with permissions to manage the system.
   */
  ADMIN = 1,

  /**
   * Represents the manager role, responsible for overseeing operations.
   */
  MANAGER = 2,

  /**
   * Represents a regular user role with limited access.
   */
  USER = 3,

  /**
   * Represents the delivery role assigned to delivery personnel.
   */
  DELIVERY = 4,
}
